import { Injectable } from '@angular/core';

import { HelperService, CampaignName } from '../../../shared/services/helper.service';
import { PermissionService } from '../../../shared/services/permissions.service';
import { AuthService } from '../../../shared/services/auth.service';

import {
  CAMPAIGN_WORKSPACE_TRANSLATIONS,
  CAMPAIGN_WORKSPACE_CONSTANTS,
} from '../../../shared/models/campaign-workspace-translations';
import { FeatureCriteriaForm, CampaignFeatureConfig, FeatureTypes } from '../../../shared/interfaces';
import { NewCampaign } from '../../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class CampaignDriveConfigService {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly helperService: HelperService,
    private readonly authService: AuthService
  ) {}

  parseCampaignFeatureConfig(response: any): CampaignFeatureConfig {
    const campaignMainConfig = response[FeatureTypes.FEA_CAMPAIGN_MAIN];
    const campaignTimelineConfig = response[FeatureTypes.FEA_CAMPAIGN_TIMELINE];

    const headerLabel = this.helperService.translateConfigCampaignNameToLocalizationKey(
      campaignMainConfig?.campaignName as CampaignName,
      CAMPAIGN_WORKSPACE_TRANSLATIONS.CAMPAIGN_NAME
    );

    const linksLabel = this.helperService.translateConfigCampaignNameToLocalizationKey(
      campaignMainConfig?.campaignName as CampaignName,
      CAMPAIGN_WORKSPACE_TRANSLATIONS.CAMPAIGN_NAME_PROJECTS
    );

    const newCampaignLabel = this.helperService.translateConfigCampaignNameToLocalizationKey(
      campaignMainConfig?.campaignName as CampaignName,
      NewCampaign
    );

    return {
      headerLabel: headerLabel ?? null,
      linksLabel: linksLabel ?? null,
      newCampaignLabel: newCampaignLabel ?? null,

      isStandAloneSearchEnabled: !!campaignMainConfig?.hasCncManager || !!campaignMainConfig?.hasProductDevManager,

      isCriteriaForm1Enabled: campaignTimelineConfig?.criteriaForm === FeatureCriteriaForm.CRITERIA_FORM_TIMELINE_1,
      isCriteriaForm2Enabled: campaignTimelineConfig?.criteriaForm === FeatureCriteriaForm.CRITERIA_FORM_TIMELINE_2,
      isCriteriaFormTimelineSimplified1Enabled:
        campaignTimelineConfig?.criteriaForm === FeatureCriteriaForm.CRITERIA_FORM_TIMELINE_SIMPLIFIED_1,

      hasCncManager: !!campaignMainConfig?.hasCncManager,
      hasProductDevManager: !!campaignMainConfig?.hasProductDevManager,
      hasActiveProduct: !!campaignMainConfig?.activeProduct,
      isWorkspaceEnabled: !!response[FeatureTypes.FEA_WORKSPACE_MAIN]?.active,
    };
  }

  canEditStatus(): boolean {
    return this.permissionService.isPlatformAdminOrAccountManager();
  }

  canCreateProject(userPermissionType: string): boolean {
    if (userPermissionType === CAMPAIGN_WORKSPACE_CONSTANTS.AGENCY) {
      return false;
    }
    return this.permissionService.canCreateProject();
  }

  canCreateCampaign(userPermissionType: string): boolean {
    if (userPermissionType === CAMPAIGN_WORKSPACE_CONSTANTS.AGENCY) {
      return false;
    }
    return this.permissionService.canCreateCampaign();
  }

  canDeleteCampaign(): boolean {
    return this.permissionService.canDeleteCampaign();
  }
}
